<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading {{ $t('labels.softwareInformation') }}
      v-spacer
      v-btn(small color='pink' dark, icon @click="dialog = true")
        v-icon(small) edit
    v-card-text
      v-layout(column)
        v-layout(row wrap)
          v-flex {{ $t('labels.software') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right(v-if="service.pos.cSoftware") {{ service.pos.cSoftware.selector }}
          v-flex.font-weight-regular.text-xs-right(v-else) Not Selected
        v-divider
        v-layout(row wrap)
          v-flex {{ $t('labels.plan') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right {{ service.pos.Product.productDetail }}
        v-divider
        v-layout(row wrap)
          v-flex {{ $t('labels.monthly') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right {{ service.pos.softwareFee | currency }}
        v-divider
        v-layout(row wrap v-if="!service.csp4")
          v-flex {{ $t('labels.currentVersion') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right {{ location.softwareCurrentVersion }}
        v-divider(v-if="!service.csp4")
        v-layout(row wrap v-if="!service.csp4")
          v-flex {{ $t('labels.versionLimit') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right {{ location.UpdateSoftwareVersion }}
        v-divider(v-if="!service.csp4")
        v-layout(row wrap v-if="location.leadID")
          v-flex {{ $t('labels.convertedLeadID') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right {{ location.leadID }}
        v-divider(v-if="location.leadID")
        v-layout(row wrap)
          v-flex {{ $t('labels.lastUsed') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right
            span {{ location.AttandanceDateTime | moment("MM/DD/YYYY") }} |
            v-tooltip(bottom='')
              template(v-slot:activator='{ on }')
                a(v-on='on' @click="openTransaction") {{ location.AttandanceDateTime | moment("from", "now") }}
              span {{ $t('labels.viewLast20Transaction') }}
        v-divider
        v-layout(row wrap)
          v-flex {{ $t('labels.ipAddressList') }}
          v-spacer
          v-flex.font-weight-regular.text-xs-right
            a(@click="getIpAddressList()") View List
        v-divider
        v-layout(row wrap)
          v-flex Update Host Address
          v-spacer
          v-flex.font-weight-regular.text-xs-right
            a(@click="updateHostAddress()") Update Host
    IPAddressList(:storeID="location.storeID" :ipAddressDialog="showIpAddress" @close="showIpAddress = false")
    Last20TransactionList(:storeID="location.storeID" :transactionDialog="transactionDialog" @close="closeTransaction")
    v-dialog(v-model='dialog', persistent max-width='300')
      v-card
        v-toolbar.elevation-0(height="45" color="gray")
          v-toolbar-title
            h1.subheading {{ $t('labels.plan') }}
        v-card-text(v-if="!isLoading")
          v-layout(row wrap)
            v-flex(xs12)
              v-select(
                :items="comboBoxByID(3).ComboBoxDetails"
                :label="$t('labels.software')"
                :error-messages="softwareErrors"
                item-text="selector"
                item-value="id"
                v-model="editLocation.cSoftwareID")
            v-flex(xs12 v-if="checkRightStatus(11)")
              v-select(
                :items="softwareProduct"
                :error-messages="productErrors"
                :label="$t('labels.plan')"
                item-text="productDetail"
                item-value="productID"
                v-model="editLocation.productID")
            v-flex(xs12 v-if="checkRightStatus(10)")
              v-text-field.right-input(v-model="editLocation.softwareFee"
                :error-messages="softwareFeeErrors"
                label='Fee')

        v-divider
        v-card-actions
          v-spacer
          v-btn(color='info', flat, @click='close') Close
          v-btn(color='info'  @click='update') update

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Last20TransactionList from "../Last20TransactionList";
import locationService from "../../service.js";
import globalService from "../../../Global/service.js";
import IPAddressList from "../../../Global/components/IPAddressList";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");

export default {
  data() {
    return {
      dialog: false,
      isLoading: true,
      transactionDialog: false,
      showIpAddress: false,
      softwareProduct: [],
      editLocation: null,
    };
  },
  components: {
    IPAddressList,
    Last20TransactionList,
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    close() {
      this.dialog = false;
    },
    update() {
      let editData = {
        cSoftwareID: this.editLocation.cSoftwareID,
        productID: this.editLocation.productID,
        softwareFee: this.editLocation.softwareFee,
      };
      return locationService
        .updateProductRelation(
          this.editLocation.storeID,
          this.service.pos.serviceID,
          this.editLocation
        )
        .then((result) => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: "success",
              title: "Update Successfully",
            });
          this.close();
          this.setLocation(this.editLocation.storeID);
        });
    },
    openTransaction() {
      this.transactionDialog = true;
    },
    closeTransaction() {
      this.transactionDialog = false;
    },
    getIpAddressList() {
      this.showIpAddress = true;
    },
    updateHostAddress() {
      globalService.updateHost(this.location.storeID).then((result) => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            type: "success",
            title: "Host Updated Successfully",
          });
      }).catch((error) => {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            type: "error",
            title: "Failed to update host",
          });
      });
    },
    getServiceProduct() {
      return locationService.getServiceProduct(this.service.pos.serviceID).then((result) => {
        console.log("product", result);
        this.softwareProduct = result.data;
      });
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.getServiceProduct();
        this.editLocation = JSON.parse(JSON.stringify(this.location));
        this.isLoading = false;
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    editLocation: {
      cSoftwareID: {
        required,
        minValue: minValue(1),
      },
      productID: {
        required,
        minValue: minValue(1),
      },
      softwareFee: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("location", ["location", "service"]),
    ...mapGetters("global", ["comboBox", "comboBoxByID", "checkRightStatus"]),
    softwareErrors() {
      const errors = [];
      if (!this.$v.editLocation.cSoftwareID.$dirty) return errors;
      if (!this.$v.editLocation.cSoftwareID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    productErrors() {
      const errors = [];
      if (!this.$v.editLocation.productID.$dirty) return errors;
      if (!this.$v.editLocation.productID.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
    softwareFeeErrors() {
      const errors = [];
      if (!this.$v.editLocation.softwareFee.$dirty) return errors;
      if (!this.$v.editLocation.softwareFee.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      return errors;
    },
  },
};
</script>

<style scoped></style>
